const SwitchBarButton = () => (
  <div className="w-1/6">
    <button className="text-dark-gray h-6 w-full rounded-full bg-white text-center text-sm">SEND MESSAGE</button>
  </div>
);

export default SwitchBarButton;
